"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get hasDefaultTableVisibility () {
        return hasDefaultTableVisibility;
    },
    get hasTableVisibilityAccess () {
        return hasTableVisibilityAccess;
    },
    get hasViewersAndUpTableVisibility () {
        return hasViewersAndUpTableVisibility;
    },
    get repopulateCreateTableSystemColumns () {
        return repopulateCreateTableSystemColumns;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _columnHelpers = require("~/helpers/columnHelpers");
const _getUniqueName = require("~/helpers/getUniqueName");
const _ncconfig = require("~/utils/nc-config");
const _utils = require("~/utils");
const _models = require("~/models");
const repopulateCreateTableSystemColumns = (_context, { columns, clientType })=>{
    const tableSystemColumns = (0, _columnHelpers.TableSystemColumns)(_utils.isEE && clientType === _ncconfig.DriverClient.PG);
    // check meta column support and filter out
    const strictOneColumnUidt = tableSystemColumns.filter((col)=>!col.allowNonSystem).map((col)=>col.uidt);
    const result = [
        ...tableSystemColumns.map((col)=>{
            delete col.allowNonSystem;
            col.cn = col.column_name;
            return col;
        }),
        // remove all UIDT ID and Order from request
        ...columns.filter((col)=>!strictOneColumnUidt.includes(col.uidt))
    ];
    for(let i = result.length - 1; i >= tableSystemColumns.length; i--){
        const col = result[i];
        // check if title, column name or uidt is intersecting with system columns
        const intersectingSystemCols = tableSystemColumns.filter((sysCol)=>sysCol.title === col.title || sysCol.column_name === col.column_name);
        for (const sysCol of intersectingSystemCols){
            if (sysCol.uidt === col.uidt && (sysCol.title === col.title || col.title === undefined) && (sysCol.column_name === col.column_name || col.column_name === undefined)) {
                // identic with system cols, so we remove it
                result.splice(i, 1);
                continue;
            }
            if (col.title && col.title === sysCol.title) {
                col.title = (0, _getUniqueName.getUniqueColumnAliasName)(result, col.title);
            }
            if (col.column_name && col.column_name === sysCol.column_name) {
                col.column_name = (0, _getUniqueName.getUniqueColumnName)(result, col.column_name);
                col.cn = col.column_name;
            }
        }
        (0, _columnHelpers.deleteColumnSystemPropsFromRequest)(col);
    }
    return result;
};
function hasDefaultTableVisibility(tableId, permissions) {
    // Find TABLE_VISIBILITY permission for this table
    const visibilityPermission = permissions.find((p)=>p.entity === _nocodbsdk.PermissionEntity.TABLE && p.entity_id === tableId && p.permission === _nocodbsdk.PermissionKey.TABLE_VISIBILITY);
    // If no permission exists, it defaults to Everyone (default visibility)
    // When "Everyone" is selected in UI, the permission is deleted
    return !visibilityPermission;
}
function hasViewersAndUpTableVisibility(tableId, permissions) {
    // Find TABLE_VISIBILITY permission for this table
    const visibilityPermission = permissions.find((p)=>p.entity === _nocodbsdk.PermissionEntity.TABLE && p.entity_id === tableId && p.permission === _nocodbsdk.PermissionKey.TABLE_VISIBILITY);
    // Check if permission is "Viewers & up" (granted_type: 'role', granted_role: 'viewer')
    if (visibilityPermission) {
        return visibilityPermission.granted_type === _nocodbsdk.PermissionGrantedType.ROLE && visibilityPermission.granted_role === _nocodbsdk.PermissionRole.VIEWER;
    }
    return false;
}
async function hasTableVisibilityAccess(context, tableId, user, permissions) {
    // Get permissions if not provided
    if (!permissions) {
        if (!context.permissions) context.permissions = await _models.Permission.list(context, context.base_id);
        permissions = context.permissions;
    }
    // if user not defined then check if table have default visibility for all users
    if (!user) {
        return hasDefaultTableVisibility(tableId, context.permissions);
    }
    // Base owners always have access
    // Check base_roles (can be string or object)
    const baseRoles = (0, _nocodbsdk.extractRolesObj)(user == null ? void 0 : user.base_roles);
    if (baseRoles == null ? void 0 : baseRoles[_nocodbsdk.ProjectRoles.OWNER]) {
        return true;
    }
    // Also check roles object for backward compatibility
    const roles = (0, _nocodbsdk.extractRolesObj)(user == null ? void 0 : user.roles);
    if (roles == null ? void 0 : roles[_nocodbsdk.ProjectRoles.OWNER]) {
        return true;
    }
    // Find TABLE_VISIBILITY permission for this table
    const visibilityPermission = permissions.find((p)=>p.entity === _nocodbsdk.PermissionEntity.TABLE && p.entity_id === tableId && p.permission === _nocodbsdk.PermissionKey.TABLE_VISIBILITY);
    // If no permission exists, default to everyone (accessible)
    if (!visibilityPermission) {
        return true;
    }
    // Get the user's project role (base role)
    // Use getProjectRole from nocodb-sdk which extracts the role from user object
    // It looks at user.base_roles and returns the most powerful role
    const userRole = (0, _nocodbsdk.getProjectRole)(user);
    // If no role found, user doesn't have access
    if (!userRole) {
        return false;
    }
    // Check if user has permission
    const hasPermission = await _models.Permission.isAllowed(context, visibilityPermission, {
        id: user.id,
        role: userRole
    });
    return hasPermission;
}
